import { render, staticRenderFns } from "./fenBaoDetail.vue?vue&type=template&id=bbdb7c12&scoped=true"
import script from "./fenBaoDetail.vue?vue&type=script&lang=js"
export * from "./fenBaoDetail.vue?vue&type=script&lang=js"
import style0 from "./fenBaoDetail.vue?vue&type=style&index=0&id=bbdb7c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdb7c12",
  null
  
)

export default component.exports